import React from 'react';
import '../Settings.scss';

/**
 * Shared table component for all counts/admin tables.
 *
 * cols: Array of column definitions:
 *   { label, key, fmt?, right?, className?, width? }
 *   - fmt(value, row): optional formatter, may return a string or JSX
 *   - right: right-align header + cell
 *   - className: applied to both <th> and <td>
 *   - width: fixed column width (CSS value)
 *
 * rows: Array of plain objects.
 *
 * rowKey: Field name to use as the React key (defaults to row index).
 *
 * rowStyle(row): Optional function returning an inline style for each <tr>.
 */
const DataTable = ({ cols, rows, rowKey, rowStyle }) => (
    <table className="drilldown-country-table">
        <thead>
            <tr>
                {cols.map(c => (
                    <th
                        key={c.key}
                        className={c.className}
                        style={{
                            ...(c.width ? { width: c.width } : {}),
                            ...(c.right ? { textAlign: 'right' } : {}),
                        }}
                    >
                        {c.label}
                    </th>
                ))}
            </tr>
        </thead>
        <tbody>
            {rows.map((row, i) => (
                <tr
                    key={rowKey ? row[rowKey] : i}
                    style={rowStyle ? rowStyle(row) : undefined}
                >
                    {cols.map(c => (
                        <td
                            key={c.key}
                            className={c.className}
                            style={c.right ? { textAlign: 'right' } : undefined}
                        >
                            {c.fmt ? c.fmt(row[c.key], row) : row[c.key]}
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    </table>
);

export default DataTable;
